<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 21">
    <g clip-path="url(#clip0_6892_8953)">
      <path
        d="M21.151 2.602L19.1564 0.611482C18.3586 -0.198945 16.9339 -0.198945 16.136 0.611482L3.22831 13.4788L0.777832 21.0001L8.25748 18.4835L21.151 5.61622C21.9915 4.79158 21.9915 3.42665 21.151 2.602ZM3.44201 17.4456L4.35382 14.6304L7.10348 17.3887L4.31108 18.3271L3.42776 17.4456H3.44201ZM5.23713 13.493L13.0587 5.68731L16.0648 8.68731L8.24323 16.493L5.23713 13.493ZM14.0702 4.67783L15.1103 3.63992L18.1164 6.63992L17.0763 7.67783L14.0702 4.67783ZM20.1537 4.60674L19.1279 5.63044L16.1218 2.63044L17.1476 1.60674C17.4183 1.3366 17.8884 1.3366 18.1591 1.60674L20.1537 3.59726C20.4386 3.88162 20.4386 4.32238 20.1537 4.60674Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8953">
        <rect width="21" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
